<template>
  <div class="developer-info">
    <!-- URL: {{ $route.path }}<br> -->
    Вер. {{ curVersion }}
  </div>

  <network-status />

  <pull-refresh v-model="pageRefreshing" pulling-text="👇" loosing-text="👍" loading-text="" success-text="" pull-distance="100" @refresh="refreshPage">
    <my-loader label="Обновляем..." v-if="pageRefreshing" />

    <main-menu ref="mainMenu" />

    <div class="wrapper" v-swipe-right="openMainMenu">
      <div class="content">
        <div v-show="needAppUpdate">
          <popup-message :visible="true" :close="() => needAppUpdate = false">
            <check-updates ref="checkUpdates" />
          </popup-message>
        </div>
        <router-view v-slot="{ Component }">
          <transition name="fade">
            <keep-alive :include="keepAlivePages">
              <component :is="Component" />
            </keep-alive>
          </transition>
        </router-view>
      </div>
    </div>
  </pull-refresh>

  <bottom-main-menu @openMainMenu="openMainMenu" />
</template>

<script>
import { delay } from "@/helpers/delay";
import PullRefresh from "pull-refresh-vue3";
import NetworkStatus from "@/components/UI/NetworkStatus";
import MainMenu from "@/components/MainMenu";
import BottomMainMenu from "@/components/BottomMainMenu";
import CheckUpdates from "@/components/CheckUpdatesPage";
import PopupMessage from "@/components/UI/PopupMessage";
import * as appConf from "../package.json";

export default {
  components: {
    PullRefresh,
    NetworkStatus,
    MainMenu,
    BottomMainMenu,
    CheckUpdates,
    PopupMessage,
  },
  data() {
    return {
      pageRefreshing: false,
      url: '',
      needAppUpdate: false,
      curVersion: ''
    }
  },
  methods: {
    openMainMenu() {
      this.$refs.mainMenu.openMenu();
    },
    async refreshPage() {
      this.pageRefreshing = true;
      await delay(200);
      window.location.reload(true);
    },
  },
  computed: {
    keepAlivePages() {
      const menuTop = MainMenu.computed.menuTop();
      const menuBottom = MainMenu.computed.menuBottom();
      return [
        ...menuTop.filter(v => v.keepAlive).map(v => v.componentName),
        ...menuBottom.filter(v => v.keepAlive).map(v => v.componentName)
      ];
    }
  },
  beforeCreate() {
    this.$store.dispatch('init');
  },
  created() {
    this.curVersion = appConf?.version || '';
  },
  mounted() {
    const autoCheckUpdates = async () => {
      if (!this.$refs.checkUpdates) {
        return;
      }

      await this.$refs.checkUpdates.checkUpdates();
      this.needAppUpdate = this.$refs.checkUpdates.hasUpdates;
    }

    autoCheckUpdates();
  },
}
</script>

<style lang="scss">
@import "@/styles/scss/bootstrap-overwrite.scss";
@import "~bootstrap/scss/bootstrap";
@import "@/styles/scss/font-ptsans.scss";
@import "@/styles/scss/keyframes.scss";
@import "@/styles/scss/my-vars.scss";

html {
  height: 100vh;
  min-width: $site-min-width;

  * {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /* make transparent link selection, adjust last value opacity 0 to 1.0 */
    outline: none !important;
  }

  .developer-info {
    position: fixed;
    right: 0;
    top: 0;
    color: #FFF;
    padding: 5px 9px;
    line-height: 1;
    font-size: 11px;
    display: inline-block;
    background: #222;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.99);
    border-radius: 0 0 0 6px;
    z-index: 1;
    //display: none;
  }

  // Component pull-to-update
  .lb-pull-refresh__head {
    display: flex;
    justify-content: center;
    color: #FFF;
    font-size: 1.1rem;
    filter: grayscale(1);
    //background: #222;
    //width: 50px;
    //left: calc(50% - 25px);
    //border-radius: 50%;
    //margin: 0 auto;
    //text-align: center;

    .pull-text {
      // @extend .spinner-border;
      @include animation('appear 0.75s 1');
    }
  }

  body {
    min-width: $site-min-width;
    width: 100%;
    max-width: $site-max-width;
    height: 100vh;
    -webkit-touch-callout: none; /* prevent callout to copy image, etc when tap to hold */
    -webkit-text-size-adjust: none; /* prevent webkit from resizing text to fit */
    -webkit-user-select: none; /* prevent copy paste, to allow, change 'none' to 'text' */
    margin: 0 auto;
    padding: 0;
    color: #FFF;
    font-family: 'PT Sans', 'HelveticaNeue-Light', 'HelveticaNeue', Helvetica, Arial, sans-serif;
    background: #000;
    font-size: 17px;

    &.with-dots {
      background-image: radial-gradient(circle, #161616 1px, rgba(0,0,0,0) 1px);
      background-repeat: repeat;
      background-size: 1rem 1rem;
    }

    #app {
      min-height: 100%;
      width: 100%;

      .wrapper {
        min-height: 100vh;
        width: 100%;
        display: flex;
        padding-bottom: 60px;

        .content {
          align-self: center;
          width: 100%;
          margin: 15px 0;
          padding: 0 15px;
          background: #000;
        }
      }

      .default-page {
        margin: 0 auto;
        max-width: 1024px;
        min-height: calc(100vh - 60px);

        &-center {
          min-height: unset !important;
        }
      }

      h3 {
        margin-top: 20px;
        margin-bottom: 10px;
        line-height: 1;

        small {
          display: block;
          font-size: 15px;
          margin-left: -2px;
          line-height: 1;
        }

        span {
          //border-bottom: 1px solid rgba(255, 255, 255, 0.15);
          padding-bottom: 5px;
        }
      }

      input[readonly] {
        color: #777;
      }
    }
  }
}

// Transition для появления компонентов
.fade {
  &-enter-active {
    transition: opacity 0.33s ease;
  }
  &-leave-active {
    display: none;
  }
  &-enter-from,
  &-leave-to {
    opacity: 0;
  }
}
</style>